const Warehouse = () => {
  return (
    <div>
      <div className="">
        <img src="/logisticsBanner/banner-3.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
          <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
          
            <div className="flex flex-col justify-center">
              <h1 className="font-bold text-3xl text-[#373737]">
                Warehousing & Distribution
              </h1>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                TCS established its W&D segment in 2004 to expedite certain processes,
                undertake vertical integration and increase its range of services.
                Over the last decade and a half, we have accumulated a list of
                partners and customers that encompasses almost all business sectors.
              </p>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                With almost c.1,000,000 sq/ft of warehousing space across Pakistan,
                our W&D services go hand in hand with our already extensive delivery
                infrastructure which is why our clients have the distinct and
                unmistakable benefit of leveraging these facilities to meet their
                ever-changing needs including storage, short-haul, long-haul and
                multi-modal movements. Our extensive list of products and services
                includes:
              </p>
              <ul className="list-disc list-inside">
                <li>Ambient & Temperature Sensitive Warehousing</li>
                <li>State of the Art Warehousing Management System (WMS)</li>
                <li>24/7 CCTV Surveillance </li>
                <li>Stock Management</li>
                <li>Inventory Track & Trace</li>
                <li>Reverse Logistics</li>
                <li>Last Mile Delivery</li>
                <li>Primary & Secondary z</li>
                <li>Value-Added Services (Re-Packing & Other Facilities)</li>
              </ul>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                For further details, please contact us at 111-123-456.
              </p>
            </div>
            <div className="flex-1 flex flex-col justify-center items-center">
              <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
            </div>
          </div>
      
      </div>
    </div>
  );
};

export default Warehouse;
